// paginationSettings.ts
import { create } from "zustand";

interface pageState {
  pageSize: number;
  setPageSize: (page: number) => void;
}

interface paginationState {
  currentPage: number;
  setCurrentPage: (page: number) => void;
}

export const usePageState = create<pageState>()((set) => ({
  pageSize: 8,
  setPageSize: (pageSize: number) => set({ pageSize }),
}));

export const useSetPage = create<paginationState>()((set) => ({
  currentPage: 1,
  setCurrentPage: (currentPage: number) => set({ currentPage }),
}));
